import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_TASK } from "./actionTypes";
import { registerTaskSuccessful, registerTaskFailed } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

// Is user register successfull then direct plot user in redux.
function* registerTask({ payload: { task, history } }) {
  try {
    const response = yield call(
      tasksAPI.newTask,
      task.sgtTaskid,
      task.priority,
      task.workstationCandidates,
      task.estimatedDurationSeconds,
      task.rackCode,
      task.face,
      task.token
    );
    yield put(registerTaskSuccessful(response.message));
  } catch (error) {
    console.log("errorCatch", error);
    yield put(registerTaskFailed(error));
  }
}

export function* watchTaskRegister() {
  yield takeEvery(REGISTER_TASK, registerTask);
}

function* registerTaskSaga() {
  yield all([fork(watchTaskRegister)]);
}

export default registerTaskSaga;
